import React from 'react';
import styled from 'styled-components'
import { media } from '../styles/Mixin'
import NormalText from './NormalText';
import Input from './SearchInput';
import useInput from '../Hooks/useInput';
import { useMutation } from '@apollo/react-hooks';
import { CREATE_CATEGORY } from '../Queries/createCategory';
import { useState } from 'react';
import { SEE_CATEGORIES } from '../Queries/seeCategories';





export default ({
    setCreateCategoryWindow,
    channelId,
}) => {
    const [CraeteCategoryMutation] = useMutation(CREATE_CATEGORY, {
        update(cache, { data: { createCategory } }) {
            const { seeCategories } = cache.readQuery({ query: SEE_CATEGORIES, variables: { userChannelId: channelId } })
            cache.writeQuery({
                query: SEE_CATEGORIES,
                variables: {
                    userChannelId: channelId
                },
                data: { seeCategories: [...seeCategories, createCategory] }
            })
        }
    })
    const ctgName = useInput("")
    const [state, setState] = useState(false)
    const createBtn = async () => {
        setState(true)
        if (ctgName.value === "") {
            alert("카테고리명을 입력해주세요 😅")
        } else {
            await CraeteCategoryMutation({
                variables: {
                    categoryName: ctgName.value
                }
            })
            setCreateCategoryWindow(false)
        }
        setState(false)
    }

    return (
        <Wrapper>
            <Box>
                <Header>
                    <NormalText text={"새 카테고리"} />
                </Header>
                <Content>
                    <GuidText text={"카테고리명을 입력해주세요 😄"} />
                    <CustomInput placeholder={"카테고리명"} {...ctgName} required={true} />
                </Content>
                <Footer>
                    <CancelBtn onClick={() => { setCreateCategoryWindow(false) }} disabled={state}>
                        <CancelText text={"🙅🏻취소"} />
                    </CancelBtn>
                    <CreateBtn onClick={createBtn} disabled={state}>
                        <CreateText text={"✔️만들기"} />
                    </CreateBtn>
                </Footer>
            </Box>
        </Wrapper>
    )
}



const Wrapper = styled.div`
    position:fixed;
    top:0;
    left:0;
    background-color: rgba(0, 0, 0, 0.5);
    height:100%;
    width:100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

const Box = styled.div`
   position:absolute;
   display:flex;
   flex-direction:column;
   background-color:white;
   ${media.deskTop`
    width:500px;
    height:450px;
   `}
    ${media.mobile`
        width:100%;
        height:300px;
    `}
`

const Header = styled.div`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    padding:10px;
    top:0;
    height:40px;
    border-bottom:${props => props.theme.boxBorder};
`

const Content = styled.div`
    width:100%;
    height:100%;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    margin-bottom:50px;
`

const GuidText = styled(NormalText)`
    ${media.deskTop`
     font-size:30px;
   `}
    ${media.mobile`
    height:15px;
    `}
    color:grey;
    padding:20px;
`

const CustomInput = styled(Input)`
    ${media.deskTop`
     height:40px;
     width:60%;
   `}
    ${media.mobile`
    height:25px;
    width:50%;
    `}
    border-radius:10px;
`


const Footer = styled.div`
     position:relative;
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    bottom:50;
     ${media.deskTop`
     height:50px;
   `}
    ${media.mobile`
    height:40px;
    `}
    border-top:${props => props.theme.boxBorder};
    /* padding:10px; */
`

const CancelBtn = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    width:50%;
    height:100%;
    background-color:${props => props.disabled === true ? props.theme.unCheckBlack : "red"};
    cursor:pointer;
`
const CancelText = styled(NormalText)`

`

const CreateBtn = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    width:50%;
    height:100%;
    background-color:${props => props.disabled === true ? props.theme.unCheckBlack : props.theme.blueColor};
    cursor:pointer;
`

const CreateText = styled(NormalText)`
`